export default __webpack_public_path__ + "static/media/Burgundy.ed9b0ce6.jpg";